import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.isValid ? 'valid' : ''])
  }, [
    _createVNode(_component_vue_select, {
      modelValue: _ctx.selectedCountry,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedCountry = $event)),
      label: "value",
      options: _ctx.countryList,
      placeholder: _ctx.placeholder,
      components: { OpenIndicator: _ctx.OpenIndicator },
      class: _normalizeClass([_ctx.selectedCountry ? '' : 'not-selected']),
      "input-id": _ctx.inputId,
      disabled: _ctx.countryDisable,
      onOpen: _ctx.toggleLabelVisibility,
      onClose: _ctx.toggleLabelVisibility,
      onKeydown: _ctx.filterInput
    }, {
      "selected-option": _withCtx(({ value, key }) => [
        _createElementVNode("span", {
          class: _normalizeClass(`country-flag fi fi-${String(key || '').toLowerCase()}`)
        }, null, 2),
        _createElementVNode("span", null, _toDisplayString(value), 1)
      ]),
      option: _withCtx(({ value, key }) => [
        _createElementVNode("span", {
          class: _normalizeClass(`country-flag fi fi-${String(key || '').toLowerCase()}`)
        }, null, 2),
        _createElementVNode("span", null, _toDisplayString(value), 1)
      ]),
      "no-options": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.invalidCountry`)), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "placeholder", "components", "class", "input-id", "disabled", "onOpen", "onClose", "onKeydown"]),
    _createElementVNode("span", {
      class: "custom-select__label",
      style: _normalizeStyle({ opacity: _ctx.isLabelVisible ? 1 : _ctx.isValid ? 1 : 0 })
    }, _toDisplayString(_ctx.label), 5),
    _createVNode(_component_Error, { name: _ctx.name }, null, 8, ["name"])
  ], 2))
}